import { Outlet } from "react-router-dom";
import CustomModal from "../CustomModal";
import { selectedBarcodeHistoryState } from "../../utils/atoms/atoms";
import { useRecoilValue } from "recoil";
import PartInOutModalBody from "../inventory/PartInOutModalBody";
import InventoryReportHistoryModalBody from "./InventoryReportHistoryModalBody";

const InventoryReportsDashboard = () => {
  const selectedBarcodeHistory = useRecoilValue(selectedBarcodeHistoryState);
  return (
    <div className="inventory-reports-container">
      {/* <div className="d-flex gap-1 mb-2 mt-2">
        <input
          type="text"
          placeholder="Search by barcode..."
          className="barcode-search-input"
        />
        <input
          type="text"
          placeholder="Search by part id..."
          className="barcode-search-input"
        />
        <input
          type="text"
          placeholder="Search by part name..."
          className="barcode-search-input"
        />
        <input
          type="text"
          placeholder="Search by drawing..."
          className="barcode-search-input"
        />
      </div> */}
      <Outlet />

      <CustomModal
        modalTitle={selectedBarcodeHistory}
        modalBody={<InventoryReportHistoryModalBody />}
        modalId="reportHistoryModal"
      />
    </div>
  );
};

export default InventoryReportsDashboard;
